import { cn } from "@/lib/utils";

interface ChipProps {
  label: string;
  variant?: "default" | "blue" | "amber" | "dark" | "outline";
  className?: string;
}

/**
 * Pill-shaped label chip used for tool tags, skills, and process steps.
 * Hover: scale up + blue border.
 */
export function Chip({ label, variant = "default", className }: ChipProps) {
  const variants = {
    default: "bg-[#E8EDFB] text-[#1D3FE8] border border-transparent hover:border-[#1D3FE8]",
    blue: "bg-[#1D3FE8] text-white border border-transparent",
    amber: "bg-[#C4772A]/10 text-[#C4772A] border border-[#C4772A]/20 hover:border-[#C4772A]",
    dark: "bg-[#1A1A1A] text-white border border-white/10",
    outline: "bg-transparent text-[#1A1A1A] border border-[#E8E2D9] hover:border-[#1D3FE8] hover:text-[#1D3FE8]",
  };

  return (
    <span
      className={cn(
        "inline-flex items-center px-3 py-1 rounded-full text-xs font-medium font-[DM_Sans] tracking-wide transition-all duration-200 hover:scale-105 select-none",
        variants[variant],
        className
      )}
    >
      {label}
    </span>
  );
}
